import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { TensileRequirementByGrade } from "../models/TensileRequirementByGrade";

export const getTensileRequirementsByGrade = async (
	params: { versionId?: number | null },
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "TensileRequirementVersionId", value: params.versionId ?? null },
	];

	const resp = await apiService.callV2(
		"[M2].[GetTensileRequirementsByGrade]",
		parameters,
		signal,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as TensileRequirementByGrade[];
	} else {
		throw new Error(
			resp.message || "Error fetching tensile requirements by grade",
		);
	}
};

export const upsertTensileRequirements = async ({
	rev,
	effectiveDate,
	comments,
	rows,
}: {
	rev: number;
	effectiveDate: Date | null;
	comments: string | null;
	rows: TensileRequirementByGrade[];
}) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "Rev", value: rev },
		{ name: "EffectiveDate", value: effectiveDate?.toISOString() ?? null },
		{ name: "Comments", value: comments },
		{ name: "Rows", value: JSON.stringify(rows) },
	];

	const resp = await apiService.callV2(
		"[M2].[UpsertTensileRequirements]",
		parameters,
	);

	if (resp.ok) {
		return get(resp, "data.returnValue", null) as number;
	} else {
		throw new Error(resp.message || "Error upserting tensile requirements");
	}
};
